@if (v2) {
	<div class="assignees-v2">
		<div class="assignees-v2-trigger" (click)="selectAssignees()" role="button" tabindex="0">
			@if (assignees.length === 0) {
				<span class="assignees-v2-placeholder">
					{{ "ASSIGNMENT_MODAL__SELECT_ASSIGNEE" | transloco }}
				</span>
			} @else {
				<span class="assignees-v2-selected">
					@for (assignee of assignees; track assignee.id) {
						<span class="assignees-v2-chip">
							<span class="material-symbols-outlined" aria-hidden="true">
								{{ assignee.id.startsWith("usergroups/") ? "group" : "person" }}
							</span>
							{{ assignee.name }}
							@if (assignee.id.startsWith("usergroups/")) {
								<span class="assignees-v2-chip-tag">
									{{ "ASSIGNEE_PICKER__USER_GROUPS" | transloco }}
								</span>
							}
							<button
								type="button"
								class="assignees-v2-chip-remove"
								(click)="removeAssignee(assignee, $event)"
								[attr.aria-label]="'BASE__CANCEL' | transloco"
							>
								<span class="material-symbols-outlined" aria-hidden="true">close</span>
							</button>
						</span>
					}
				</span>
			}
			<span class="material-symbols-outlined assignees-v2-chevron" aria-hidden="true">chevron_right</span>
		</div>
	</div>
} @else {
	<ion-item (click)="selectAssignees()" lines="full">
		<ion-icon name="person-outline" slot="start"></ion-icon>
		<ion-label position="stacked">
			{{ "ASSIGNMENT__ASSIGNEE" | transloco }}
		</ion-label>
		@if (assignees.length === 0) {
			<div class="placeholder">
				<ion-text color="danger">{{ "ASSIGNMENT__ASSIGNEE_EMPTY" | transloco }}</ion-text>
			</div>
		} @else {
			<div class="assignees-names">
				@for (assignee of assignees; track assignee.id) {
					<li>{{ assignee.name }}</li>
				} @empty {
					<li class="placeholder">{{ "ASSIGNMENT__ASSIGNEE_EMPTY" | transloco }}</li>
				}
			</div>
		}
	</ion-item>
}
